module.exports = __webpack_public_path__ + "static/img/3-yuan-icon.0fc039f6.png";